import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "d-flex ga-3" }
const _hoisted_2 = { class: "headerReport" }
const _hoisted_3 = { class: "mb-2" }
const _hoisted_4 = { class: "mb-2" }
const _hoisted_5 = { id: "reportPDFid" }
const _hoisted_6 = {
  key: 0,
  class: "pl-4"
}
const _hoisted_7 = {
  key: 1,
  class: "pl-4"
}
const _hoisted_8 = {
  key: 0,
  class: "pl-4"
}
const _hoisted_9 = {
  key: 1,
  class: "pl-4"
}
const _hoisted_10 = {
  key: 0,
  class: "pl-4"
}
const _hoisted_11 = {
  key: 1,
  class: "pl-4"
}
const _hoisted_12 = {
  key: 0,
  class: "pl-4"
}
const _hoisted_13 = {
  key: 1,
  class: "pl-4"
}
const _hoisted_14 = {
  key: 0,
  class: "pl-4"
}
const _hoisted_15 = {
  key: 1,
  class: "pl-4"
}

import { ref, watch, Ref, computed } from "vue";
import axios from "axios";

import html2pdf from "html2pdf.js";

/********************************
 ********** COMPONENTES *********
 *******************************/
import DialogComponent from "@/components/SmartLink/dialog/dialogComponent.vue";
import Prog_circular from "@/components/PrincipalComponents/Prog_circular.vue";
import ColumnChart from "@/components/SmartLink/charts/ColumnChart.vue";

/********************************
 ************ VUETIFY ***********
 *******************************/
import { useDisplay, useTheme } from "vuetify";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";
import {
  VISIBLE_PAGES,
  STRING_GENERAL,
  TOKEN,
  NAME_PROJECT,
  LABELS,
} from "@/constants/labels";
import { FINAL_HEADERS_TABLE } from "@/constants/tableHeaders";
import { TIMEOUTTIME, APIS_REPORT } from "@/constants/apis";
import CONSTAPIS from "@/constants/apis";

/********************************
 ********** INTERFACES **********
 *******************************/
import { EQUIPAMENTS } from "@/interfaces/SmartLink/Equips";
import { ALIGN } from "@/interfaces/SmartLink/Topology";
import { SNR } from "@/interfaces/SmartLink/KPI";

/********************************
 *********** FUNCTION ***********
 *******************************/
import { showConsoleError } from "@/functions/errors";


export default /*@__PURE__*/_defineComponent({
  __name: 'ReportView',
  setup(__props) {

const theme = useTheme();
const { smAndDown } = useDisplay();

/********************************
 ************ STORE *************
 *******************************/
const store = useStore();

const projectName = computed(() => store.state.projectName);
const USER = computed(() => store.state.sesion )
const ROL = computed(() => USER.value.rol)

/********************************
 ************ I18N **************
 *******************************/
const { t } = useI18n();

/********************************
 ********** CONSTANTES **********
 *******************************/
const showInfo = ref(false);

/**
 * El tipo de la familia que se selecciona en el SELECT junto con el DATEINI - DATEFIN
 */
const familyType = ref("");

/**
 * La fecha inicial para el petido a la API
 */
const dateini = ref("");

/**
 * La fecha final para el petido a la API
 */
const datefin = ref("");

/**
 * Variable para mostrar la tabla de Latencia, se oculta por completo si no hay DATOS desde la API
 */
const showTenLAT = ref(true);

/**
 * Variable para mostrar la tabla de Quality LAP (RxLvl y AVG), se oculta por completo si no hay DATOS desde la API
 */
const showQualityLap = ref(true);

/**
 * Variable para mostrar la tabla de SNR H, se oculta por completo si no hay DATOS desde la API
 */
const showQualitySNRV = ref(true);

/**
 * Variable para mostrar la tabla de SNR V, se oculta por completo si no hay DATOS desde la API
 */
const showQualitySNRH = ref(true);
const cantOK: Ref<number[]> = ref([]);
const cantALARM: Ref<number[]> = ref([]);
const cantALERT: Ref<number[]> = ref([]);
const cantDOWN: Ref<number[]> = ref([]);
const arrayIPs: Ref<string[]> = ref([]);

const operability: Ref<SNR[]> = ref([]);
const qualityLap: Ref<any[]> = ref([]);
const latencyTen: Ref<EQUIPAMENTS[]> = ref([]);
const SNR_VERTI: Ref<SNR[]> = ref([]);
const SNR_HORIZ: Ref<SNR[]> = ref([]);


const headerQualLap = ref();
const headerSNRVert = ref();
const headerSNRHorz = ref();
const headerOperabi = ref();
const headerTenOperabi = ref();

/**
 * Realiza 4 peticiones a la API por orden
 * (operatividad, latencia, qualitylap y qualitysnr).
 * Se capturan también los Headers de cada tabla
 */
const getItems = async () => {
  // Capturamos el valor de AVG del HEADER de QUALITY SNR, ya que el header es el mismo, excepto por este valor
  let avgHeader = {
    text: computed(() => t("labels.avgpower")),
    value: "avgpower",
    sortable: true,
  };

  // Capturamos el HEADER de qualityLAP y agregamos al final el avgHEADER obtenido anteriormente
  headerQualLap.value = FINAL_HEADERS_TABLE[
    VISIBLE_PAGES.quality_lap
  ].toSpliced(4, 0, avgHeader);

  // Capturamos el HEADER de qualitySNR y se elimina el valor de snr_h o snr_v, dependiendo de lo que requiera la tabla
  headerSNRVert.value = FINAL_HEADERS_TABLE[VISIBLE_PAGES.quality_snr].filter(
    (head) => head.value !== "snr_h",
  );
  headerSNRHorz.value = FINAL_HEADERS_TABLE[VISIBLE_PAGES.quality_snr].filter(
    (head) => head.value !== "snr_v",
  );

  // Capturamos el HEADER de latency y se elimina el valor de fecha
  headerTenOperabi.value = FINAL_HEADERS_TABLE[VISIBLE_PAGES.latency].filter(
    (head) => head.value !== "fecha",
  );

  headerOperabi.value = FINAL_HEADERS_TABLE[VISIBLE_PAGES.operability];

  operability.value = [];
  qualityLap.value = [];
  latencyTen.value = [];
  SNR_VERTI.value = [];
  SNR_HORIZ.value = [];
  cantOK.value = [];
  cantALARM.value = [];
  cantALERT.value = [];
  cantDOWN.value = [];
  arrayIPs.value = [];
  showInfo.value = true;

  let params = {
    dateini: dateini.value,
    datefin: datefin.value,
    ip: "1",
    tipo: VISIBLE_PAGES.report,
    macType: familyType.value,
  };

  /**
   * Obtiene valores de Operatividad de la API: "getWorstOperability"
   * Enviando parámetros como fecha inicial, fecha final, tipo y el tipo de Familia
   */
  axios
    .get(CONSTAPIS.APIS.value.report.operability, {
      params: params,
      timeout: TIMEOUTTIME,
      headers: { Authorization: `Bearer ${TOKEN}` },
    })
    .then(async (res) => {
      let allData = res.data;
      let finalArray: SNR[] = [];
      await allData.forEach((elem: SNR) => {
        let cantTotal =
          (elem.ok ?? 0) +
          (elem.alarm ?? 0) +
          (elem.alert ?? 0) +
          (elem.down ?? 0);
        let finalItem = {
          ip: elem.ip,
          name: elem.name,
          tipo: elem.tipo,
          ok: parseFloat((((elem.ok ?? 0) / cantTotal) * 100).toFixed(2)),
          alert: parseFloat((((elem.alert ?? 0) / cantTotal) * 100).toFixed(2)),
          alarm: parseFloat((((elem.alarm ?? 0) / cantTotal) * 100).toFixed(2)),
          down: parseFloat((((elem.down ?? 0) / cantTotal) * 100).toFixed(2)),
        };
        finalArray.push(finalItem);
      });

      //ordena por la cantidad de alarmas y solo capturamos las 10 primeras
      finalArray.sort((a: SNR, b: SNR) => (b.alarm ?? 0) - (a.alarm ?? 0));
      let finalData = finalArray.slice(0, 10);

      operability.value = finalData;
      operability.value.forEach((item: SNR) => {
        cantOK.value.push(item.ok ?? 0);
        cantALARM.value.push(item.alert ?? 0);
        cantALERT.value.push(item.alarm ?? 0);
        cantDOWN.value.push(item.down ?? 0);
        arrayIPs.value.push(item.name ?? "");
      });
    })
    .catch(function (error) {
      showConsoleError(error);
    });

  /**
   * Obtiene valores de Latencia de la API: "getTENWorstLatency"
   * Enviando parámetros como fecha inicial, fecha final, tipo y el tipo de Familia
   */
  axios
    .get(CONSTAPIS.APIS.value.report.tenlatency, {
      params: params,
      timeout: TIMEOUTTIME,
      headers: { Authorization: `Bearer ${TOKEN}` },
    })
    .then(async (res) => {
      showTenLAT.value = true;

      let allData = res.data;
      if (allData.length > 0) {
        showTenLAT.value = true;
        let totalData = allData.sort(
          (a: EQUIPAMENTS, b: EQUIPAMENTS) => (b.lat ?? 0) - (a.lat ?? 0),
        ); //ordena por la latencia
        latencyTen.value = totalData;
      } else {
        showTenLAT.value = false;
      }
    })
    .catch(function (error) {
      showTenLAT.value = false;
      showConsoleError(error);
    });
  /* eslint-disable */

  /**
   * Obtiene valores de qualitylap de la API: "getWorstQualityLAP"
   * Enviando parámetros como fecha inicial, fecha final, tipo y el tipo de Familia
   */
  axios
    .get(CONSTAPIS.APIS.value.report.qualitylap, {
      params: params,
      timeout: TIMEOUTTIME,
      headers: { Authorization: `Bearer ${TOKEN}` },
    })
    .then(async (res) => {
      showQualityLap.value = true;

      let finalArray: SNR[] = [];
      let allData = res.data;
      let allRADIO: any = {};
      let allAVG: any = {};
      let RADIOrx = 0;
      let AVGtx = 0;
      if (allData.length > 0) {
        allData.forEach((elem: any) => {
          if (
            projectName.value === NAME_PROJECT.cananea ||
            projectName.value === NAME_PROJECT.hcg ||
            projectName.value === NAME_PROJECT.nacozari
          ) {
            // Convierte a JSON la variable "snr"
            // Si no trae valores, convierte el valor por defecto: "{"V": 0, "H":0, "PER": 0}"
            // Se aumentó PER : 0, por MIMOSA en Cananea
            allRADIO = JSON.parse(elem.snr ?? `{"V": 0, "H": 0, "PER": 0}`);

            // Como trae valores simples o en un array, primero se valida
            // Si existe y si es un objeto (un array), se captura el primer valor del array,
            // Caso contrario se coloca el valor único que tiene
            RADIOrx =
              (typeof allRADIO["H"]).toUpperCase() == "OBJECT" &&
              allRADIO["H"] !== null
                ? allRADIO["H"][1]
                : allRADIO["H"];

            AVGtx = allRADIO["PER"];
          } else {
            // Convierte a JSON la variable "link_radio"
            // Si no trae valores, convierte el valor por defecto: "{"tx": 0, "rx":0}"
            allRADIO = JSON.parse(elem.link_radio ?? `{"tx": 0, "rx":0}`);

            // Como trae valores simples o en un array, primero se valida
            // Si existe y si es un objeto (un array), se captura el primer valor del array,
            // Caso contrario se coloca el valor único que tiene
            RADIOrx =
              (typeof allRADIO["rx"]).toUpperCase() == "OBJECT" &&
              allRADIO["rx"] !== null
                ? allRADIO["rx"][0]
                : allRADIO["rx"];

            // Convierte a JSON la variable "avgpower"
            // Si no trae valores, convierte el valor por defecto: "{"tx": 0, "rx":0}"
            allAVG = JSON.parse(elem.avgpower ?? `{"tx": 0, "rx":0}`);

            // Como trae valores simples o en un array, primero se valida
            // Si existe y si es un objeto (un array), se captura el primer valor del array,
            // Caso contrario se coloca el valor único que tiene
            AVGtx =
              (typeof allAVG["tx"]).toUpperCase() == "OBJECT" &&
              allAVG["tx"] !== null
                ? allAVG["tx"][0]
                : allAVG["tx"];
          }

          let finalItem: SNR = {
            fecha: elem.fecha,
            name: elem.name,
            ip: elem.ip,
            tipo: elem.tipo,
            avgpower: AVGtx ?? 0,
            link_radio_rx: RADIOrx ?? 0,
          };

          finalArray.push(finalItem);
        });
        if (familyType.value === "Distribucion") {
          finalArray = finalArray.filter(
            (item: SNR) => item.subtipo !== "Distribución",
          );
        }
        let finalData = finalArray.slice(0, 5);
        qualityLap.value = finalData;
        showQualityLap.value = true;
      } else {
        showQualityLap.value = false;
      }
    })
    .catch(function (error) {
      showQualityLap.value = false;
      showConsoleError(error);
    });

  /**
   * Obtiene valores de qualitylap de la API: "getWorstQualitySNR"
   * Enviando parámetros como fecha inicial, fecha final, tipo y el tipo de Familia
   */
  axios
    .get(CONSTAPIS.APIS.value.report.qualitysnr, {
      params: params,
      timeout: TIMEOUTTIME,
      headers: { Authorization: `Bearer ${TOKEN}` },
    })
    .then(async (res) => {
      let allData = res.data;
      let finalArray_VER: SNR[] = [];
      let finalArray_HOR: SNR[] = [];
      let allSNR: any = {};
      let allAVG: any = {};
      let SNRV = 0;
      let SNRH = 0;
      let AVGtx = 0;

      allData.forEach((elem: ALIGN) => {
        // Convierte a JSON la variable "snr"
        // Si no trae valores, convierte el valor por defecto: "{"V": 0, "H":0, "PER": 0}"
        // Se aumentó PER : 0, por MIMOSA en Cananea
        allSNR = JSON.parse(elem.snr ?? `{"V": 0, "H": 0, "PER": 0}`);

        // Si es Cananea, el valor está en el index 3 del array, si es otro proyecto, será el primer valor
        let indexNumber =
          projectName.value === NAME_PROJECT.cananea ||
          projectName.value === NAME_PROJECT.demo ||
          projectName.value === NAME_PROJECT.nacozari
            ? 3
            : 0;

        // Como trae valores simples o en un array, primero se valida
        // Si existe y si es un objeto (un array), se captura el primer valor del array,
        // Caso contrario se coloca el valor único que tiene
        SNRV =
          (typeof allSNR["V"]).toUpperCase() == "OBJECT" && allSNR["V"] !== null
            ? allSNR["V"][indexNumber]
            : allSNR["V"];
        SNRH =
          (typeof allSNR["H"]).toUpperCase() == "OBJECT" && allSNR["H"] !== null
            ? allSNR["H"][indexNumber]
            : allSNR["H"];

        // Convierte a JSON la variable "avgpower"
        // Si no trae valores, convierte el valor por defecto: "{"tx": 0, "rx": 0}"
        allAVG = JSON.parse(elem.avgpower ?? `{"tx": 0, "rx":0}`);

        // Como trae valores simples o en un array, primero se valida
        // Si es Cananea, Captura el valor de PER del SNR, si es otro proyecto, valida
        // si existe y si es un objeto (un array), se captura el primer valor del array,
        // Caso contrario se coloca el valor único que tiene
        AVGtx =
          projectName.value === NAME_PROJECT.cananea ||
          projectName.value === NAME_PROJECT.demo ||
          projectName.value === NAME_PROJECT.nacozari
            ? allSNR["PER"]
            : (typeof allAVG["tx"]).toUpperCase() == "OBJECT" &&
              allAVG["tx"] !== null
            ? allAVG["tx"][0]
            : allAVG["tx"];

        let finalItemSNRH: SNR = {
          fecha: elem.fecha ?? "",
          name: elem.name ?? "",
          ip: elem.ip ?? "",
          snr_h: SNRH ?? 0,
          tipo: elem.tipo ?? "",
          subtipo: elem.subtipo ?? "",
          avgpower: AVGtx ?? 0,
        };

        let finalItemSNRV: SNR = {
          fecha: elem.fecha ?? "",
          name: elem.name ?? "",
          ip: elem.ip ?? "",
          snr_v: SNRV ?? 0,
          tipo: elem.tipo ?? "",
          subtipo: elem.subtipo ?? "",
          avgpower: AVGtx ?? 0,
        };

        finalArray_VER.push(finalItemSNRV);
        finalArray_HOR.push(finalItemSNRH);
      });

      if (familyType.value === "Distribucion") {
        finalArray_VER = finalArray_VER.filter(
          (item: SNR) => item.subtipo !== "Distribución",
        );
        finalArray_HOR = finalArray_HOR.filter(
          (item: SNR) => item.subtipo !== "Distribución",
        );
      }
      // Ordena los Valores snr_v y snr_h de mayor a menor, luego captura los 5 primeros
      finalArray_VER.sort((a: SNR, b: SNR) => (a.snr_v ?? 0) - (b.snr_v ?? 0));
      finalArray_HOR.sort((a: SNR, b: SNR) => (a.snr_h ?? 0) - (b.snr_h ?? 0));
      let finalData_VER = finalArray_VER.slice(0, 5);
      let finalData_HOR = finalArray_HOR.slice(0, 5);

      SNR_VERTI.value = finalData_VER;
      SNR_HORIZ.value = finalData_HOR;

      SNR_VERTI.value.length > 0
        ? (showQualitySNRV.value = true)
        : (showQualitySNRV.value = false);
      SNR_HORIZ.value.length > 0
        ? (showQualitySNRH.value = true)
        : (showQualitySNRH.value = false);
    })
    .catch(function (error) {
      showQualitySNRV.value = false;
      showQualitySNRH.value = false;
      showConsoleError(error);
    });
};

/**
 * Mostrar el Dialogo
 */
const dialog = ref(false);

/**
 * IP del equipo Seleccionado de la tabla para mostrar en el DIÁLOGO
 */
const selectedIp = ref("");

/**
 * Nombre del equipo Seleccionado de la tabla para mostrar en el DIÁLOGO
 */
const selectedName = ref("");

/**
 * Tipo del equipo Seleccionado de la tabla para mostrar en el DIÁLOGO
 */
const selectedType = ref("");

/**
 * Captura (ip, tipo, nombre) y lo almacena en las variables correspondientes
 * para luego abrir el dialog con la información gráfica y estadística
 * del equipo en cuestión
 * @param ip IP del equipo Seleccionado
 * @param name Nombre del equipo Seleccionado
 * @param type Tipo del equipo Seleccionado
 */
const showDialog = (ip: string, name: string, type: string) => {
  selectedIp.value = ip;
  selectedName.value = name;
  selectedType.value = type;
  dialog.value = true;
};

/**
 * Cierra el Diálogo mediante un EMIT del componente de Dialogo
 * @param value valor FALSO
 */
const closeDialog = (value: boolean) => {
  dialog.value = value;
};

/**
 * Si hay un cambio de fecha inicial o final, se ocultará toda la info
 */
watch(dateini, () => {
  showInfo.value = false;
});
watch(datefin, () => {
  showInfo.value = false;
});


const exportToPdf = () => {
  // Elemento HTML que envuelve los reportes
  const element = document.getElementById("reportPDFid");

  // Opciones de configuración del PDF
  const options = {
    margin: [10, 10, 10, 10], // top, left, bottom, right (en mm)
    filename: `Reporte_${familyType.value || "General"}_${dateini.value}_${datefin.value}.pdf`,
    image: { type: "jpeg", quality: 0.98 },
    html2canvas: {
      scale: 2, // Mayor resolución para los gráficos y tablas
      useCORS: true, // Para permitir la carga de imágenes externas si las hay
      scrollY: 0,
    },
    jsPDF: {
      unit: "mm",
      format: "a4",
      orientation: "landscape", // "landscape" o "portrait" según tu preferencia
    },
    pagebreak: { mode: ["avoid-all", "css", "legacy"] },
  };

  // Generar y descargar el documento
  html2pdf().set(options).from(element).save();
};

const generarReporte = () => {
   axios
    .get(APIS_REPORT.value.generarReporte, {
      timeout: TIMEOUTTIME,
      headers: { Authorization: `Bearer ${TOKEN}` },
    })
    .then(async (res) => {
      if(res.status === 200) {
        store.commit("showSnackBar", {
          type: LABELS.edit,
          msg: 'Se generó el reporte',
          valor: true,
        });
      }
    })
    .catch(function (error) {
      showConsoleError(error);
    });
}

const enviarReporte = () => {
  axios
    .get(APIS_REPORT.value.enviarReporte, {
      timeout: TIMEOUTTIME,
      headers: { Authorization: `Bearer ${TOKEN}` },
    })
    .then(async (res) => {
      if(res.status === 200) {
        store.commit("showSnackBar", {
          type: LABELS.add,
          msg: 'Se envió el reporte',
          valor: true,
        });
      }
    })
    .catch(function (error) {
      showConsoleError(error);
    });
}

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_VueDatePicker = _resolveComponent("VueDatePicker")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_EasyDataTable = _resolveComponent("EasyDataTable")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (ROL.value === 'desarrollador')
      ? (_openBlock(), _createBlock(_component_v_sheet, {
          key: 0,
          color: "bgtopology",
          class: _normalizeClass(["defaultCard cardReport mb-4", _unref(smAndDown) ? 'ma-1 pa-2' : 'pa-4 ma-4'])
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, { class: "ma-0 align-center justify-space-between" }, {
              default: _withCtx(() => [
                _cache[6] || (_cache[6] = _createElementVNode("div", null, [
                  _createElementVNode("h3", { class: "text-h6 font-weight-bold" }, "Ejecución de Reportes Automatizados")
                ], -1)),
                _createElementVNode("div", _hoisted_1, [
                  _createVNode(_component_v_btn, {
                    color: "primary",
                    variant: "elevated",
                    onClick: generarReporte
                  }, {
                    default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                      _createTextVNode(" Generar reporte ", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_v_btn, {
                    color: "success",
                    variant: "elevated",
                    onClick: enviarReporte
                  }, {
                    default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                      _createTextVNode(" Enviar reporte ", -1)
                    ]))]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["class"]))
      : _createCommentVNode("", true),
    _createVNode(_component_v_sheet, {
      color: "bgtopology",
      class: _normalizeClass(["defaultCard cardReport", _unref(smAndDown) ? 'ma-1 pa-2' : 'pa-4 ma-4'])
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_row, { class: "ma-0 mb-4 align-center" }, {
          default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
            _createElementVNode("h2", { class: "text-h5 font-weight-bold" }, "Consulta y Filtros de Reporte", -1)
          ]))]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                class: "py-0",
                cols: "12",
                sm: "12",
                md: "4"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("h4", _hoisted_3, _toDisplayString(_unref(t)("datePickers.dateini")), 1),
                  _createVNode(_component_VueDatePicker, {
                    class: "mb-4",
                    modelValue: dateini.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dateini).value = $event)),
                    "model-type": _unref(STRING_GENERAL).time,
                    format: _unref(STRING_GENERAL).time
                  }, null, 8, ["modelValue", "model-type", "format"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                class: "py-0",
                cols: "12",
                sm: "12",
                md: "4"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("h4", _hoisted_4, _toDisplayString(_unref(t)("datePickers.datefin")), 1),
                  _createVNode(_component_VueDatePicker, {
                    class: "mb-4",
                    modelValue: datefin.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((datefin).value = $event)),
                    "model-type": _unref(STRING_GENERAL).time,
                    format: _unref(STRING_GENERAL).time
                  }, null, 8, ["modelValue", "model-type", "format"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                class: "py-0",
                cols: "12",
                sm: "12",
                md: "4"
              }, {
                default: _withCtx(() => [
                  _cache[8] || (_cache[8] = _createElementVNode("h4", { class: "mb-2" }, "Tipo", -1)),
                  _createVNode(_component_v_select, {
                    modelValue: familyType.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((familyType).value = $event)),
                    density: "compact",
                    variant: "outlined",
                    items: ['Cliente', 'Acceso', 'Distribucion']
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, { class: "ma-0 mt-2" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                disabled: !(datefin.value > dateini.value),
                class: "mb-6",
                color: "btnSelect",
                onClick: getItems
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)("buttons.searchbtn")), 1)
                ]),
                _: 1
              }, 8, ["disabled"]),
              _createVNode(_component_v_col, { class: "pa-0 mb-6 ml-4" }, {
                default: _withCtx(() => [
                  (operability.value.length > 0)
                    ? (_openBlock(), _createBlock(_component_v_btn, {
                        key: 0,
                        color: "btnSelect",
                        onClick: exportToPdf
                      }, {
                        default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                          _createTextVNode(" Exportar a PDF ", -1)
                        ]))]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_5, [
          (showInfo.value)
            ? (_openBlock(), _createBlock(_component_v_row, {
                key: 0,
                justify: "space-around",
                class: "mt-5 pdfrow"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_divider, {
                    thickness: 10,
                    class: "border-opacity-75 divider_color d-none d-sm-none d-md-flex"
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    sm: "12",
                    md: "5",
                    lg: "5",
                    xl: "5",
                    "align-self": "center",
                    class: "colreport mx-n4 my-6"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_sheet, {
                        class: "defaultCard",
                        color: "white"
                      }, {
                        default: _withCtx(() => [
                          (_unref(smAndDown))
                            ? (_openBlock(), _createElementBlock("h5", _hoisted_6, _toDisplayString(_unref(t)("reportPage.subtitle1")), 1))
                            : (_openBlock(), _createElementBlock("h3", _hoisted_7, _toDisplayString(_unref(t)("reportPage.subtitle1")), 1)),
                          (operability.value.length > 0)
                            ? (_openBlock(), _createBlock(_component_EasyDataTable, {
                                key: 2,
                                "header-class-name": "headerColor",
                                "theme-color": "#0e2f5a",
                                headers: headerOperabi.value,
                                items: operability.value,
                                alternating: "",
                                "show-index": "",
                                "hide-footer": ""
                              }, {
                                "item-ok": _withCtx((item) => [
                                  _createTextVNode(_toDisplayString(item.ok) + "% ", 1)
                                ]),
                                "item-alarm": _withCtx((item) => [
                                  _createTextVNode(_toDisplayString(item.alarm) + "% ", 1)
                                ]),
                                "item-alert": _withCtx((item) => [
                                  _createTextVNode(_toDisplayString(item.alert) + "% ", 1)
                                ]),
                                "item-down": _withCtx((item) => [
                                  _createTextVNode(_toDisplayString(item.down) + "% ", 1)
                                ]),
                                "item-ip": _withCtx((item) => [
                                  _createVNode(_component_v_btn, {
                                    color: "blue",
                                    variant: "plain",
                                    onClick: ($event: any) => (showDialog(item.ip, item.name, item.tipo))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(item.ip), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"])
                                ]),
                                _: 1
                              }, 8, ["headers", "items"]))
                            : (_openBlock(), _createBlock(_component_v_sheet, {
                                key: 3,
                                class: "text-center mt-6",
                                color: "transparent"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(Prog_circular)
                                ]),
                                _: 1
                              }))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_divider, {
                    thickness: 10,
                    class: "border-opacity-75 divider_color d-none d-sm-none d-md-flex",
                    vertical: ""
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    sm: "12",
                    md: "5",
                    lg: "5",
                    xl: "5",
                    class: "colreport2 mx-n4 my-6"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_sheet, {
                        class: "defaultCard",
                        color: "white"
                      }, {
                        default: _withCtx(() => [
                          (cantOK.value.length > 0)
                            ? (_openBlock(), _createBlock(ColumnChart, {
                                key: 0,
                                class: "pa-4 graphColumn3D",
                                color: "#000000",
                                title: _unref(t)('reportPage.subtitle1'),
                                name: "Reporte",
                                firstArray: cantOK.value,
                                secondArray: cantALARM.value,
                                thridArray: cantALERT.value,
                                fourthArray: cantDOWN.value,
                                arrayIPs: arrayIPs.value
                              }, null, 8, ["title", "firstArray", "secondArray", "thridArray", "fourthArray", "arrayIPs"]))
                            : (_openBlock(), _createBlock(_component_v_sheet, {
                                key: 1,
                                class: "text-center mt-6",
                                color: "transparent"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(Prog_circular)
                                ]),
                                _: 1
                              }))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  (showTenLAT.value)
                    ? (_openBlock(), _createBlock(_component_v_divider, {
                        key: 0,
                        thickness: 10,
                        class: "border-opacity-75 divider_color d-none d-sm-none d-md-flex"
                      }))
                    : _createCommentVNode("", true),
                  (showTenLAT.value)
                    ? (_openBlock(), _createBlock(_component_v_col, {
                        key: 1,
                        cols: "12",
                        sm: "12",
                        md: "10",
                        lg: "10",
                        xl: "10",
                        class: "colreport3 mx-n4 my-6"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_sheet, {
                            class: "defaultCard",
                            color: "white"
                          }, {
                            default: _withCtx(() => [
                              (_unref(smAndDown))
                                ? (_openBlock(), _createElementBlock("h5", _hoisted_8, "Latencia"))
                                : (_openBlock(), _createElementBlock("h3", _hoisted_9, "Latencia")),
                              (latencyTen.value.length > 0)
                                ? (_openBlock(), _createBlock(_component_EasyDataTable, {
                                    key: 2,
                                    "header-class-name": "headerColor",
                                    "theme-color": "#0e2f5a",
                                    headers: headerTenOperabi.value,
                                    items: latencyTen.value,
                                    alternating: "",
                                    "show-index": "",
                                    "hide-footer": ""
                                  }, {
                                    "item-latencia": _withCtx((item) => [
                                      _createTextVNode(_toDisplayString(item.latencia.toFixed(2)) + "ms ", 1)
                                    ]),
                                    "item-ip": _withCtx((item) => [
                                      _createVNode(_component_v_btn, {
                                        color: "blue",
                                        variant: "plain",
                                        onClick: ($event: any) => (showDialog(item.ip, item.name, item.tipo))
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(item.ip), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"])
                                    ]),
                                    _: 1
                                  }, 8, ["headers", "items"]))
                                : (_openBlock(), _createBlock(_component_v_sheet, {
                                    key: 3,
                                    class: "text-center mt-6",
                                    color: "transparent"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(Prog_circular)
                                    ]),
                                    _: 1
                                  }))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (showQualityLap.value)
                    ? (_openBlock(), _createBlock(_component_v_divider, {
                        key: 2,
                        thickness: 10,
                        class: "border-opacity-75 divider_color d-none d-sm-none d-md-flex"
                      }))
                    : _createCommentVNode("", true),
                  (showQualityLap.value)
                    ? (_openBlock(), _createBlock(_component_v_col, {
                        key: 3,
                        cols: "12",
                        sm: "12",
                        md: "10",
                        lg: "10",
                        xl: "10",
                        class: "colreport3 mx-n4 my-6"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_sheet, {
                            class: "defaultCard",
                            color: "white"
                          }, {
                            default: _withCtx(() => [
                              (_unref(smAndDown))
                                ? (_openBlock(), _createElementBlock("h5", _hoisted_10, _toDisplayString(_unref(t)("reportPage.subtitle2")), 1))
                                : (_openBlock(), _createElementBlock("h3", _hoisted_11, _toDisplayString(_unref(t)("reportPage.subtitle2")), 1)),
                              (qualityLap.value.length > 0)
                                ? (_openBlock(), _createBlock(_component_EasyDataTable, {
                                    key: 2,
                                    "header-class-name": "headerColor",
                                    "theme-color": "#0e2f5a",
                                    headers: headerQualLap.value,
                                    items: qualityLap.value,
                                    alternating: "",
                                    "show-index": "",
                                    "hide-footer": ""
                                  }, {
                                    "item-link_radio_rx": _withCtx((item) => [
                                      _createVNode(_component_v_row, { style: {"align-items":"center !important"} }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_col, {
                                            cols: "2",
                                            class: "pa-0"
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("span", null, _toDisplayString(item.link_radio_rx), 1)
                                            ]),
                                            _: 2
                                          }, 1024),
                                          _createVNode(_component_v_col, { cols: "10" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_progress_linear, {
                                                "model-value": -item.link_radio_rx,
                                                height: "10",
                                                striped: "",
                                                color: 
                        item.link_radio_rx <= -85
                          ? '#ff0000'
                          : item.link_radio_rx <= -80
                          ? '#ff5050'
                          : item.link_radio_rx <= -75
                          ? '#ff9900'
                          : item.link_radio_rx <= -70
                          ? '#ffff00'
                          : item.link_radio_rx <= -65
                          ? '#ccff33'
                          : item.link_radio_rx <= -60
                          ? '#66ff33'
                          : item.link_radio_rx <= -55
                          ? '#40f7eb'
                          : item.link_radio_rx <= -50
                          ? '#3790fc'
                          : item.link_radio_rx <= -45
                          ? '#2d09f7'
                          : item.link_radio_rx <= -40
                          ? '#3b1ace'
                          : item.link_radio_rx <= -35
                          ? '#7009c4'
                          : item.link_radio_rx <= -33.6
                          ? '#8a079b'
                          : '#c8c8c8'
                      
                                              }, null, 8, ["model-value", "color"])
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    "item-ip": _withCtx((item) => [
                                      _createVNode(_component_v_btn, {
                                        color: "blue",
                                        variant: "plain",
                                        onClick: ($event: any) => (showDialog(item.ip, item.name, item.tipo))
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(item.ip), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"])
                                    ]),
                                    _: 1
                                  }, 8, ["headers", "items"]))
                                : (_openBlock(), _createBlock(_component_v_sheet, {
                                    key: 3,
                                    class: "text-center mt-6",
                                    color: "transparent"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(Prog_circular)
                                    ]),
                                    _: 1
                                  }))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (showQualitySNRV.value || showQualitySNRH.value)
                    ? (_openBlock(), _createBlock(_component_v_divider, {
                        key: 4,
                        thickness: 10,
                        class: "border-opacity-75 divider_color d-none d-sm-none d-md-flex"
                      }))
                    : _createCommentVNode("", true),
                  (showQualitySNRV.value)
                    ? (_openBlock(), _createBlock(_component_v_col, {
                        key: 5,
                        cols: "12",
                        sm: "12",
                        md: "5",
                        lg: "5",
                        xl: "5",
                        class: "colreport4 mx-n4 my-6"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_sheet, {
                            class: "defaultCard",
                            color: "white"
                          }, {
                            default: _withCtx(() => [
                              (_unref(smAndDown))
                                ? (_openBlock(), _createElementBlock("h5", _hoisted_12, _toDisplayString(_unref(t)("reportPage.subtitleV")), 1))
                                : (_openBlock(), _createElementBlock("h3", _hoisted_13, _toDisplayString(_unref(t)("reportPage.subtitleV")), 1)),
                              (SNR_VERTI.value.length > 0)
                                ? (_openBlock(), _createBlock(_component_EasyDataTable, {
                                    key: 2,
                                    "header-class-name": "headerColor",
                                    "theme-color": "#0e2f5a",
                                    headers: headerSNRVert.value,
                                    items: SNR_VERTI.value,
                                    alternating: "",
                                    "show-index": "",
                                    "hide-footer": ""
                                  }, {
                                    "item-vertical": _withCtx((item) => [
                                      _createVNode(_component_v_row, {
                                        justify: "space-between",
                                        style: {"align-items":"center !important"}
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_col, {
                                            cols: "2",
                                            class: "pa-0"
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("span", null, _toDisplayString(item.vertical), 1)
                                            ]),
                                            _: 2
                                          }, 1024),
                                          _createVNode(_component_v_col, {
                                            cols: "10",
                                            class: "pa-0 pr-2"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_progress_linear, {
                                                "model-value": 100,
                                                height: "10",
                                                striped: "",
                                                color: 
                        item.vertical <= 15
                          ? '#FF0000'
                          : item.vertical <= 20
                          ? '#FFEE00'
                          : '#00FF00'
                      
                                              }, null, 8, ["color"])
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    "item-ip": _withCtx((item) => [
                                      _createVNode(_component_v_btn, {
                                        color: "blue",
                                        variant: "plain",
                                        onClick: ($event: any) => (showDialog(item.ip, item.name, item.tipo))
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(item.ip), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"])
                                    ]),
                                    _: 1
                                  }, 8, ["headers", "items"]))
                                : (_openBlock(), _createBlock(_component_v_sheet, {
                                    key: 3,
                                    class: "text-center mt-6",
                                    color: "transparent"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(Prog_circular)
                                    ]),
                                    _: 1
                                  }))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (showQualitySNRH.value && showQualitySNRV.value)
                    ? (_openBlock(), _createBlock(_component_v_divider, {
                        key: 6,
                        thickness: 10,
                        class: "border-opacity-75 divider_color d-none d-sm-none d-md-flex",
                        vertical: ""
                      }))
                    : _createCommentVNode("", true),
                  (showQualitySNRH.value)
                    ? (_openBlock(), _createBlock(_component_v_col, {
                        key: 7,
                        cols: "12",
                        sm: "12",
                        md: "5",
                        lg: "5",
                        xl: "5",
                        class: "colreport5 mx-n4 my-6"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_sheet, {
                            class: "defaultCard card5",
                            color: "white"
                          }, {
                            default: _withCtx(() => [
                              (_unref(smAndDown))
                                ? (_openBlock(), _createElementBlock("h5", _hoisted_14, _toDisplayString(_unref(t)("reportPage.subtitleH")), 1))
                                : (_openBlock(), _createElementBlock("h3", _hoisted_15, _toDisplayString(_unref(t)("reportPage.subtitleH")), 1)),
                              (SNR_HORIZ.value.length > 0)
                                ? (_openBlock(), _createBlock(_component_EasyDataTable, {
                                    key: 2,
                                    "header-class-name": "headerColor",
                                    "theme-color": "#0e2f5a",
                                    headers: headerSNRHorz.value,
                                    items: SNR_HORIZ.value,
                                    alternating: "",
                                    "show-index": "",
                                    "hide-footer": ""
                                  }, {
                                    "item-horizontal": _withCtx((item) => [
                                      _createVNode(_component_v_row, {
                                        justify: "space-between",
                                        style: {"align-items":"center !important"}
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_col, {
                                            cols: "2",
                                            class: "pa-0"
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("span", null, _toDisplayString(item.horizontal), 1)
                                            ]),
                                            _: 2
                                          }, 1024),
                                          _createVNode(_component_v_col, {
                                            cols: "10",
                                            class: "pa-0 pr-6"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_progress_linear, {
                                                "model-value": 100,
                                                height: "10",
                                                striped: "",
                                                color: 
                        item.horizontal <= 15
                          ? '#FF0000'
                          : item.horizontal <= 20
                          ? '#FFEE00'
                          : '#00FF00'
                      
                                              }, null, 8, ["color"])
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    "item-ip": _withCtx((item) => [
                                      _createVNode(_component_v_btn, {
                                        color: "blue",
                                        variant: "plain",
                                        onClick: ($event: any) => (showDialog(item.ip, item.name, item.tipo))
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(item.ip), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"])
                                    ]),
                                    _: 1
                                  }, 8, ["headers", "items"]))
                                : (_openBlock(), _createBlock(_component_v_sheet, {
                                    key: 3,
                                    class: "text-center mt-6",
                                    color: "transparent"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(Prog_circular)
                                    ]),
                                    _: 1
                                  }))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["class"]),
    _createVNode(_component_v_dialog, {
      modelValue: dialog.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((dialog).value = $event)),
      width: "85%"
    }, {
      default: _withCtx(() => [
        _createVNode(DialogComponent, {
          ip: selectedIp.value,
          typeSel: selectedType.value,
          name: selectedName.value,
          onDialog: closeDialog
        }, null, 8, ["ip", "typeSel", "name"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})